import { teamMemberService } from '../../../services/OrganizationTeamMember'
import {
  ActionsUnion,
  IOrganizationTeamMember,
  IOrganizationTeamMemberInvite,
  IOrganizationTeamMemberWithUserResponse,
  IStateOrganizationTeamMember,
  StateOrganizationTeamMemberMap,
  StateUserMap,
  StateUserRoleMap,
  IOrganizationTeamMemberUpdateDTO,
  IMemberFilters,
  IMemberSearchObject
} from '../../../types'
import { IAction, Id } from '../../../types/common'
import * as constants from '../../constants'
import { createAction } from '../helpers'
;(window as any).teamMemberService = teamMemberService

export type ITeamMemberAction = ActionsUnion<typeof actionCreators>

export const actionCreators = {
  //Async action creators
  updateTeamMemberFilters: (filters: IMemberFilters) => createAction(constants.UPDATE_TEAM_MEMBER_FILTERS, filters),
  teamMemberListRequest: () => createAction(constants.TEAM_MEMBER_LIST_REQUEST),
  teamMemberListSuccess: (payload: { total: number; items: IMemberSearchObject[] }) =>
    createAction(constants.TEAM_MEMBER_LIST_SUCCESS, payload),
  teamMemberListFail: (error: string) => createAction(constants.TEAM_MEMBER_LIST_FAIL, error),
  resetTeamMemberFilters: () => createAction(constants.RESET_TEAM_MEMBER_FILTERS),

  teamMemberInviteRequest: () => createAction(constants.TEAM_MEMBER_INVITE_REQUEST),
  teamMemberInviteSuccess: (teamMember: IMemberSearchObject) =>
    createAction(constants.TEAM_MEMBER_INVITE_SUCCESS, teamMember),
  teamMemberInviteFail: (error: string) => createAction(constants.TEAM_MEMBER_INVITE_FAIL, error),

  fetchTeamMemberRequest: () => createAction(constants.TEAM_MEMBER_FETCH_REQUEST),
  fetchTeamMemberSuccess: (payload: IMemberSearchObject) => createAction(constants.TEAM_MEMBER_FETCH_SUCCESS, payload),
  fetchTeamMemberFail: (error: string) => createAction(constants.TEAM_MEMBER_FETCH_FAIL, error),

  teamMemberUpdateRequest: () => createAction(constants.TEAM_MEMBER_UPDATE_REQUEST),
  teamMemberUpdateSuccess: (teamMember: IMemberSearchObject) =>
    createAction(constants.TEAM_MEMBER_UPDATE_SUCCESS, teamMember),
  teamMemberUpdateFail: (error: string) => createAction(constants.TEAM_MEMBER_UPDATE_FAIL, error),

  teamMemberArchiveRequest: () => createAction(constants.TEAM_MEMBER_ARCHIVE_REQUEST),
  teamMemberArchiveSuccess: (teamMember: IStateOrganizationTeamMember) =>
    createAction(constants.TEAM_MEMBER_ARCHIVE_SUCCESS, teamMember),
  teamMemberArchiveFail: (error: string) => createAction(constants.TEAM_MEMBER_ARCHIVE_FAIL, error),

  teamMemberRestoreRequest: () => createAction(constants.TEAM_MEMBER_RESTORE_REQUEST),
  teamMemberRestoreSuccess: (teamMember: IStateOrganizationTeamMember) =>
    createAction(constants.TEAM_MEMBER_RESTORE_SUCCESS, teamMember),
  teamMemberRestoreFail: (error: string) => createAction(constants.TEAM_MEMBER_RESTORE_FAIL, error)
}

export function getMany(filters: IMemberFilters): any {
  const { teamMemberListRequest, teamMemberListSuccess, teamMemberListFail } = actionCreators
  return (dispatch: any) => {
    dispatch(teamMemberListRequest())
    return teamMemberService.getMany(filters).then(
      (payload: { total: number; items: IMemberSearchObject[] }) => {
        dispatch(teamMemberListSuccess(payload))
        return payload
      },
      error => {
        return dispatch(teamMemberListFail(error))
      }
    )
  }
}

export const inviteTeamMember = (teamMember: IOrganizationTeamMemberInvite) => async (dispatch: any) => {
  const { teamMemberInviteRequest, teamMemberInviteSuccess, teamMemberInviteFail } = actionCreators
  dispatch(teamMemberInviteRequest())
  return teamMemberService.inviteTeamMember(teamMember).then(
    teamMember => {
      dispatch(teamMemberInviteSuccess(teamMember))
      return teamMember
    },
    data => {
      return dispatch(teamMemberInviteFail(data))
    }
  )
}

export const fetchTeamMember = (id: Id) => async (dispatch: any) => {
  const { fetchTeamMemberRequest, fetchTeamMemberSuccess, fetchTeamMemberFail } = actionCreators
  dispatch(fetchTeamMemberRequest())
  try {
    const response = await teamMemberService.fetchTeamMember(id)
    dispatch(fetchTeamMemberSuccess(response))
    return response
  } catch (e) {
    return dispatch(fetchTeamMemberFail(e.message))
  }
}

export const updateTeamMember = (teamMember: IOrganizationTeamMemberUpdateDTO) => (dispatch: any) => {
  const { teamMemberUpdateRequest, teamMemberUpdateSuccess, teamMemberUpdateFail } = actionCreators
  dispatch(teamMemberUpdateRequest())
  return teamMemberService.updateOne(teamMember).then(
    teamMember => {
      dispatch(teamMemberUpdateSuccess(teamMember))
      return teamMember
    },
    ({ data }) => {
      return dispatch(teamMemberUpdateFail(data))
    }
  )
}

export const moveToArchive = (teamMember: IMemberSearchObject) => (dispatch: any) => {
  const { teamMemberArchiveRequest, teamMemberArchiveSuccess, teamMemberArchiveFail } = actionCreators
  dispatch(teamMemberArchiveRequest())
  return teamMemberService.moveToArchive(teamMember).then(
    teamMember => {
      dispatch(teamMemberArchiveSuccess(teamMember))
      return teamMember
    },
    ({ data }) => {
      dispatch(teamMemberArchiveFail(data))
    }
  )
}

export const restoreFromArchive = (teamMember: IMemberSearchObject) => (dispatch: any) => {
  const { teamMemberRestoreRequest, teamMemberRestoreSuccess, teamMemberRestoreFail } = actionCreators
  dispatch(teamMemberRestoreRequest())
  return teamMemberService.restoreFromArchive(teamMember).then(
    teamMember => {
      dispatch(teamMemberRestoreSuccess(teamMember))
      return teamMember
    },
    ({ data }) => {
      dispatch(teamMemberRestoreFail(data))
    }
  )
}

export const sendResetPasswordLink = (teamMember: IMemberSearchObject) => (dispatch: any) => {
  return teamMemberService.sendResetPasswordLink(teamMember).then(
    teamMember => {
      return teamMember
    },
    error => {
      throw new Error(error)
    }
  )
}

export const sendInvite = (teamMember: IMemberSearchObject) => (dispatch: any) => {
  return teamMemberService.sendInvite(teamMember).then(
    teamMember => {
      return teamMember
    },
    error => {
      throw new Error(error)
    }
  )
}



// WEBPACK FOOTER //
// ./src/state/actions/team_members/index.ts